import React from 'react'
import X from '@mui/icons-material/X';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { Link } from 'react-router-dom';
import { Icon } from '@mui/material';
import theme from '../Theme';

function Links({size,color}) {
    let links=[
        {Icon:GitHubIcon,href:"https://github.com/Sharief2854"},
        {Icon:LinkedInIcon,href:"https://www.linkedin.com/in/sharief-k-89a046169/"},
        {Icon:InstagramIcon,href:"https://www.instagram.com/mr.sharif2854/"},
        {Icon:FacebookIcon,href:"https://www.facebook.com/kadapa.sharief"},
        {Icon:X,href:"https://x.com/Sharief05411856"}
    ]
  return (
    <>
        {
            links.map((obj)=>
            {
                return(
                    <Link 
                        to={obj.href}
                        target='__blank'
                        key={obj}
                    >
                        <Icon  
                            component={obj.Icon} 
                            sx={{
                                width:{xs:`${size.xs}px`,sm:`${size.sm}px`,md:`${size.md}px`},
                                height:{xs:`${size.xs}px`,sm:`${size.sm}px`,md:`${size.md}px`},
                                color:color,
                                transition:"all 0.1s linear 0s",

                                '&:hover':{
                                    transform:"translateY(-4px)",
                                    color:'text.primary'
                                }
                            }}
                        />
                    </Link>
                )
            })
        }
    </>
  )
}

export default Links